var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAngular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 46,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M18.033 24.236h7.923l-3.964-9.401-3.96 9.401ZM21.993.017.314 7.644l3.306 28.29 18.371 10.049 18.377-10.04 3.305-28.296L21.992.02V.017Zm13.527 35.07h-5.052l-2.722-6.71H16.241l-2.722 6.71H8.463L21.994 5.094 35.52 35.086Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngular);
export default __webpack_public_path__ + "static/media/angular.5793ac926c81bad878fc01ed632a9379.svg";
export { ForwardRef as ReactComponent };